<template>
  <v-col class="ma-5" v-if="!['PEF', 'ASPIRANT'].includes(current_user.role)">
    <v-row>
      <v-col cols="6">
        <v-sheet>
          <div class="mx-auto pa-8">
            {{ $t("greeting") }}
            {{ current_user.first_name }} {{ current_user.last_name }}
          </div>
        </v-sheet>
      </v-col>
      <v-col cols="6">
        <v-sheet>
          <div class="mx-auto pa-8">
            <v-select
              :clearable="true"
              v-model="dayFilter"
              :items="daysFilters"
              item-value="key"
              :label="$t('home.filters.title')"
              :item-text="(item) => $t('home.filters.' + item.key)"
            ></v-select>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="6" :sm="12" :lg="6">
        <last-feedbacks :startDate="dayFilter" />
      </v-col>
      <v-col :cols="6" :sm="12" :lg="6">
        <last-pef-diary :startDate="dayFilter" />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="6" :sm="12" :lg="6">
        <last-interventions :startDate="dayFilter" />
      </v-col>
      <v-col :cols="6" :sm="12" :lg="6">
        <last-aos :startDate="dayFilter" />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import LastFeedbacks from "../components/card/LastFeedbacks"
import LastInterventions from "@/components/card/LastInterventions"
import LastAos from "@/components/card/LastAos"
import LastPefDiary from "@/components/card/LastPefDiary"

export default {
  components: {
    LastPefDiary,
    LastAos,
    LastInterventions,
    LastFeedbacks,
  },
  data: () => ({
    dayFilter: null,
    daysFilters: [{ key: "4" }, { key: "10" }],
  }),
  mounted() {
    this.redirect(this.$store.state.user.profile)
  },
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
  },
  watch: {
    current_user(value) {
      this.redirect(value)
    },
  },

  methods: {
    redirect(value) {
      if (["PEF", "ASPIRANT"].includes(value.role)) {
        this.$router.push({
          name: "users",
          params: { user_id: this.current_user.id },
        })
      }
    },
  },
}
</script>
